<template>
    <v-dialog
        v-model="showDialog"
        max-width="850"
    >
        <v-card>
            <course-booking :courseId="course.id" dialog @close="showDialog = false" />

            <v-card-actions>
                <v-spacer></v-spacer>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import CourseBooking from '../views/CourseBooking.vue'
export default {
    name: 'zoezi-coursebooking-dialog',
    props: ['value', 'booking'],

    components: {
        CourseBooking
    },

    watch: {
        value: {
            immediate: true,
            handler(value) {
                this.showDialog = value;
            }
        },
        showDialog(value) {
            this.$emit('input', value);
        },
        booking: {
            immediate: true,
            handler() {
                if (this.booking && this.course.id != this.booking.course_id) {
                    this.$api.get('/api/public/course/get', {id: this.booking.course_id}).then(courses => {
                        this.course = courses[0];
                    });
                }
            }
        }
    },
    data: () => ({
        showDialog : false,
        course: {}
    })
}
</script>
